import { IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { NetezzaTableDataset } from 'app/model/dataset/netezza.dataset';
import { TabularCopySource } from './tabular-type.copysource';

import { partitionOptionConst } from 'app/registries/consts/metadata-consts';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.netezza.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(NetezzaTableDataset) }
})
export class NetezzaCopySource extends TabularCopySource {
    public static readonly PARTITION_OPTION: IAttribute;
    public static readonly PARTITION_COLUMN_NAME: IAttribute;
    public static readonly PARTITION_UPPER_BOUND: IAttribute;
    public static readonly PARTITION_LOWER_BOUND: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_OPTION',

        display: stringResources.ModelName_Partition_Option
    })
    public partitionOption?: string = partitionOptionConst.dataSlice; // default value is dataSlice

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_COLUMN_NAME',
        display: stringResources.ModelName_Partition_ColumnName
    })
    public partitionColumnName?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_UPPER_BOUND',
        display: stringResources.ModelName_Partition_UpperBound
    })
    public partitionUpperBound?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_LOWER_BOUND',
        display: stringResources.ModelName_Partition_LowerBound
    })
    public partitionLowerBound?: string;
}
